import { Injectable } from '@angular/core';
import { Restaurant } from '../models/restaurant.model';
import { CartStore } from '../stores/cart.store';
import { RestaurantStore } from '../stores/restaurant.store';
import { PaymentStore } from '../stores/payment.store';
import { FulfillmentType } from '../models/order.model';

@Injectable({
  providedIn: 'root'
})
export class MinMaxOrderService {
  public isMinErrorMessage: boolean;
  public isMaxErrorMessage: boolean;
  public minOrder: number = 0;
  public maxOrder: number = 0;

  public chooseScheduledTimeRequired(restaurant: Restaurant): boolean {
    return !restaurant.isAcceptingOrders && restaurant.allowScheduledPickups;
  }

  private get isGroup(): boolean {
    return this.restaurantStore.isGroup;
  }

  constructor(
    private cartStore: CartStore,
    private restaurantStore: RestaurantStore,
    private paymentStore: PaymentStore
  ) { }

  public checkMinMaxOrder(restaurant: Restaurant, orderType: FulfillmentType): boolean {
    this.setMinMax(restaurant, orderType);
    if (this.chooseScheduledTimeRequired(restaurant)) {
      return this.cartStore.pickupAt == null || (this.isMinErrorMessage && this.isMaxErrorMessage);
    }
    return this.isMinErrorMessage && this.isMaxErrorMessage;
  }

  public checkMinMaxOrderDelivery(restaurant: Restaurant, orderType: FulfillmentType): boolean {
    this.setMinMax(restaurant, orderType);
    return this.isMinErrorMessage && this.isMaxErrorMessage;
  }

  public checkMinMaxOrderTableSide(restaurant: Restaurant, isTabOptional: boolean, isTabNumberValid: boolean): boolean {
    const orderType = this.paymentStore.createTabChecked ? FulfillmentType.TAB : FulfillmentType.TABLESIDE;
    this.setMinMax(restaurant, orderType);
    if (restaurant.isTabsEnabled && !this.isGroup) {
      return !isTabOptional || isTabNumberValid || (this.isMinErrorMessage && this.isMaxErrorMessage);
    }
    return isTabNumberValid || (this.isMinErrorMessage && this.isMaxErrorMessage);
  }

  public checkMinMaxOrderHandoff(restaurant: Restaurant, isTabNumberValid: boolean, orderType: FulfillmentType): boolean {
    this.setMinMax(restaurant, orderType);
    return isTabNumberValid || (this.isMinErrorMessage && this.isMaxErrorMessage);
  }

  private setMinMax(restaurant: Restaurant, orderType: FulfillmentType): void {
    const minimum = restaurant.minMaxRestrictions[orderType].minimum;
    const maximum = restaurant.minMaxRestrictions[orderType].maximum;
    if (minimum === 0) {
      this.isMinErrorMessage = false;
    } else {
      this.isMinErrorMessage = minimum / 100 > this.cartStore.totalPrice;
      this.minOrder = minimum / 100;
    }
    if (maximum === 0) {
      this.isMaxErrorMessage = false;
    } else {
      this.isMaxErrorMessage = maximum / 100 < this.cartStore.totalPrice;
      this.maxOrder = maximum / 100;
    }
  }
}
